//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { massiveSelectRequestsMixin } from '@/apps/data-platform/mixins/massive_select_requests';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import { textsDefaul, ACCESS_TYPE_FLOW } from '@/js/constants';
import utils from '@/js/utils';
import FormChangeMetaDataWorkbook from '@/components/tableau/FormChangeMetaDataWorkbook';
import FormAccessRequestWorkbook from '@/components/tableau/FormAccessRequestWorkbook';
import DialogsComponent from '@/components/DialogsComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
export default {
  name: 'ListWorkbookAccessRequested',
  mixins: [massiveSelectRequestsMixin],
  components: {
    FormChangeMetaDataWorkbook: FormChangeMetaDataWorkbook,
    FormAccessRequestWorkbook: FormAccessRequestWorkbook,
    DialogsComponent: DialogsComponent,
    StateComponent: StateComponent
  },
  props: {
    typeFlow: {
      type: String,
      required: true,
      default: ''
    },
    titlePage: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: function data() {
    return {
      MODAL_WORKBOOK_CHANGE_METADATA: 'MODAL_WORKBOOK_CHANGE_METADATA',
      MODAL_WORKBOOK_ACCESS_REQUEST: 'MODAL_WORKBOOK_ACCESS_REQUEST',
      messageEmptyListDs: textsDefaul.LOADING,
      title_modal: 'View Metadata Change (Validation)',
      commentary: '',
      response_text: '',
      item: Object,
      lst_workbook: [],
      messageEmptyListWb: textsDefaul.LOADING,
      currentModal: '',
      filter: '',
      titleModal: '',
      key_meta: 1,
      key_access: 1
    };
  },
  computed: {
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    tableauFieldsWb: function tableauFieldsWb() {
      return [{
        text: this.traductor('my_pendings.tablas.dashboard'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.request_date'),
        value: 'created_datetime',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'center'
      }];
    }
  },
  created: function created() {
    this.reloadWorkBook();
  },
  methods: {
    onSearch: function onSearch(text) {
      this.filter = text;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    reloadWorkBook: function reloadWorkBook() {
      var _this = this;
      var typeFlow = this.typeFlow;
      var email = window.userInfo.email;
      var domain = window.userInfo.domain;
      this.lst_workbook = [];
      TableauDashboardService.tableauWorkBookPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this.lst_workbook = response.data.items;
          } else {
            _this.lst_workbook = [];
            _this.messageEmptyListWb = textsDefaul.NOT_FOUND;
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onTableauOwnerWb: function onTableauOwnerWb(item) {
      var modalName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.item = item;
      this.key_meta += 1;
      this.key_access += 1;
      if (item.type === ACCESS_TYPE_FLOW.ACCESS) {
        this.currentModal = modalName || this.MODAL_WORKBOOK_ACCESS_REQUEST;
      } else if (item.type === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        this.currentModal = this.MODAL_WORKBOOK_CHANGE_METADATA;
      }
      this.titleModal = "WORKBOOK: ".concat(item.objectReference.path_name, "/").concat(item.objectReference.object_name);
      //this.$bvModal.show(this.currentModal)
      this.$refs[this.currentModal].onOpen();
    },
    onCloseModalWb: function onCloseModalWb() {
      var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      //this.$bvModal.hide(this.currentModal)
      this.$refs[this.currentModal].onClose();
      if (reload) {
        this.reloadWorkBook();
      }
    }
  }
};